import { languageMap } from ".."

languageMap.false = {
	comments: {
		block: ["{", "}"],
	},
}
